<template>
  <div v-if="showOnce" v-show="show">
    <slot />
  </div>
  <!--/* 
    ・タブの中身を初回表示するまで、中身で使用するAjaxは飛ばしたくない（=v-ifを使う）
    ・一度タブを表示したらタブの中身を破棄したくない（=v-showを使う）
    を満たすためのコンポーネント。
  */-->
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import { Watch } from 'vue-property-decorator';

@Options({
  props:{
    show:{
    }
  }
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;

  readonly show!:Object;
  once = false //一度trueになったら二度とfalseにならない

  get showOnce(){
    return this.once ? true: this.show
  }
  
  @Watch("show", { immediate: true, deep: false })
  onShowChanged(){
    if(this.show){
      this.once = true
    }
  }
}
</script>
<style lang="scss" scoped>
</style>